import {FormBuilder, Validators} from '@angular/forms';
import {IWidgetStyling, WIDGET_STYLING_FIELDS} from '../../../../models/widget-styling.model';

export function createWidgetStylingForm(fb: FormBuilder, value: IWidgetStyling = {}) {
  return fb.group(Object.fromEntries(WIDGET_STYLING_FIELDS.map(field => [
    field.key,
    [value[field.key] ?? null, [
      Validators.min(field.min), Validators.max(field.max), Validators.pattern(/^\d+$/)
    ]]
  ])));
}
